import { KeyedObject, OneOrArrayOf, Uuid } from '../../types';

const queryString = require( 'query-string' );

import _          from 'underscore';
import { ROUTES } from '../../constants/RouteEnums';

export class RouterUtility {

	static REDIRECT_PARAM = 'redirect';

	static getSubdomain = ( s: string = null ): string | null => {

		let hostname = s ?? window.location.hostname;

		let parts                              = hostname.split( '.' ),
		    [ tld, domain, ...subdomainParts ] = parts.reverse();

		domain = [ domain, tld ].join( '.' );

		let subdomain = typeof subdomainParts !== 'string' ? subdomainParts.join( '.' ) : subdomainParts;

		return ( subdomain ) ? null : subdomain;
	}

	static getRoute = ( pathInput: OneOrArrayOf<string>, params: KeyedObject = {} ) => {

		return RouterUtility.placeParamsInPath(
			RouterUtility.getRoutePath( pathInput ) as string,
			params
		);
	};

	static getRoutePath = ( pathInput: OneOrArrayOf<string>, asParts: boolean = false, routeObject: KeyedObject = ROUTES ): OneOrArrayOf<string> => {

		let path        = ( typeof pathInput === 'string' ) ? pathInput.split( '.' ) : _.flatten( pathInput ) as string[],
		    result      = routeObject[ _.first( path ) ],
		    hasMorePath = ( path.length > 1 ),
		    route: OneOrArrayOf<string>;

		if( result && !_.isObject( result ) ){

			route = result;

		} else if( result.ROOT ){

			if( hasMorePath && result.CHILDREN ){

				route = `${ result.ROOT }${ RouterUtility.getRoutePath( _.rest( path ), false, result.CHILDREN ) }`;

			} else if( !hasMorePath ){

				route = `${ result.ROOT }`;

			} else {

				throw new Error( `Route has no CHILDREN defined as ${ path }` );
			}

		} else {

			throw new Error( `Route has no ROOT defined at ${ path }` );
		}

		if( asParts && typeof route === 'string' ){
			return route.split( '/' ) as string[];
		}

		return route;
	};

	static pathContainsFragment = ( path: OneOrArrayOf<string>, frgamentToMatch: string ) => {

		return ( path.indexOf( frgamentToMatch ) !== -1 );
	};

	static getRedirectURLorRoute = ( defaultRoute = '/' ) => {

		let redirectParam = RouterUtility.REDIRECT_PARAM,
		    currentURL    = new URL( window.location.href );

		// eg /about/page?redirect=login
		if( currentURL.searchParams.has( redirectParam ) ){
			return currentURL.searchParams.get( redirectParam );
		}

		return defaultRoute;
	};

	static getLoginURL( redirect: string = null ){

		let loginRoute = ROUTES.LOGIN;

		if( redirect ){

			loginRoute = queryString.stringifyUrl( {
				url:   loginRoute,
				query: {
					[ RouterUtility.REDIRECT_PARAM ]: redirect
				},
			} );
		}

		return loginRoute;
	}

	static tokenizeRoute( route: OneOrArrayOf<string> ){

		let splitChar    = '/',
		    tokenizeChar = ':';

		let requiresConversion = ( s: string ) => ( s.indexOf( tokenizeChar ) > -1 ),
		    converterToToken   = ( s: string ) => `{${ s.replace( tokenizeChar, '' ) }}`;

		if( typeof route === 'string' ){
			route = route.split( splitChar );
		}

		route = route.map( part => requiresConversion( part )
		                           ? converterToToken( part )
		                           : part ).join( splitChar );

		return route;
	}

	static placeParamsInPath( pathRegex: string, params: KeyedObject = {} ){

		let segments = pathRegex.split( "/" );

		const regex = new RegExp( '(:)(.*)(=)(.*)', 'gm' );

		let [ segmentsWithValues, segmentsWithoutValues ] = _.partition( segments, segmentPath => ( regex.exec( segmentPath ) !== null ) ),
		    segmentParams                                 = {};

		// map segment paths to values
		segmentsWithValues.map( s => {
			let [ key, value ]   = s.substr( 1 ).split( '=' );
			segmentParams[ key ] = value;
		} )

		// update params with additional info
		params = { ...segmentParams, ...params };

		let newPathSegments = segmentsWithoutValues.map( segment => {

			let offset = segment.indexOf( ":" ) + 1;

			if( !offset ) return segment;

			let key                 = segment.slice( offset ),
			    indexOfOptionalFlag = key.indexOf( "?" ),
			    keyIsOptional       = ( indexOfOptionalFlag > -1 ),
			    paramsContainKey    = !_.contains( [ null, undefined, '' ], params[ key.substring( 0, indexOfOptionalFlag ) ] );

			if( keyIsOptional ){

				return paramsContainKey ? params[ key.substring( 0, indexOfOptionalFlag ) ] : '';

			} else {

				return params[ key ]
			}

		} );

		return `/${ _.compact( newPathSegments ).join( "/" ) }`;
	}

	// Checks to see if the current location is within a project specific path based on an id
	// (any page under that project, eg /project/<projectId>)
	static isCurrentURLProjectSpecific( path:string, projectId: Uuid  ){

		return RouterUtility.pathContainsFragment( path, RouterUtility.placeParamsInPath( ROUTES.PROJECT.ROOT, { projectId } ) )
	}
}
